import { render, staticRenderFns } from "./NoticeList.vue?vue&type=template&id=cfd52814&scoped=true&"
import script from "./NoticeList.vue?vue&type=script&lang=js&"
export * from "./NoticeList.vue?vue&type=script&lang=js&"
import style0 from "./NoticeList.vue?vue&type=style&index=0&id=cfd52814&prod&lang=scss&scoped=true&"
import style1 from "./NoticeList.vue?vue&type=style&index=1&id=cfd52814&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd52814",
  null
  
)

export default component.exports